module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/hosts_header.2a20ad8b.png";